(function () {

  function filterGallery(selectedValue) {
    const val = selectedValue.trim().toLowerCase();

    const thumbItems = document.querySelectorAll('li.thumbnail-list__item');
    const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');

    // Pre-check: does any MEDIA item alt text match the selected value?
    // Use media items as the authority — if no media matches, don't touch anything
    const anyMediaMatch = Array.from(mediaItems).some(function (item) {
      const img = item.querySelector('img');
      return img && (img.getAttribute('alt') || '').trim().toLowerCase() === val;
    });

    if (!anyMediaMatch) return; // Exit without touching anything

    let firstMatchThumb = null;

    // Filter thumbnail strip (desktop)
    thumbItems.forEach(function (li) {
      const img = li.querySelector('img');
      if (!img) return;
      const alt = (img.getAttribute('alt') || '').trim().toLowerCase();
      const match = alt === val;
      if (match && !firstMatchThumb) firstMatchThumb = li;
      li.style.display = match ? '' : 'none';
    });

    // Filter main media slides
    mediaItems.forEach(function (item) {
      const img = item.querySelector('img');
      if (!img) return;
      const alt = (img.getAttribute('alt') || '').trim().toLowerCase();
      const match = alt === val;
      item.style.display = match ? '' : 'none';
    });

    // Click first matching thumbnail to trigger Spotlight's slider navigation
    if (firstMatchThumb) {
      const thumbBtn = firstMatchThumb.querySelector('button, a');
      if (thumbBtn) thumbBtn.click();
    }
  }

  function getMultiVariantsColorText() {
    const select = document.querySelector('select[id^="multivariants_"][id$="_select_0"]');
    if (!select) return null;
    return select.options[select.selectedIndex]
      ? select.options[select.selectedIndex].text.trim()
      : null;
  }

  // Listen for MultiVariants color dropdown change
  document.addEventListener('change', function (e) {
    if (
      e.target &&
      e.target.id &&
      /^multivariants_.*_select_0$/.test(e.target.id)
    ) {
      const colorText = e.target.options[e.target.selectedIndex].text.trim();
      if (colorText) filterGallery(colorText);
    }
  });

  // Wait for DOM to stabilize then apply initial filter
  function waitForStable() {
    var lastCount = 0;
    var stableRounds = 0;

    var interval = setInterval(function () {
      var thumbCount = document.querySelectorAll('li.thumbnail-list__item').length;
      var mediaCount = document.querySelectorAll('.product__media-list .product__media-item').length;
      var currentCount = thumbCount + mediaCount;
      var val = getMultiVariantsColorText();

      if (currentCount > 0 && currentCount === lastCount) {
        stableRounds++;
      } else {
        stableRounds = 0;
      }

      lastCount = currentCount;

      if (stableRounds >= 3 && val) {
        clearInterval(interval);
        filterGallery(val);
      }
    }, 200);
  }

  window.addEventListener('load', waitForStable);

})();
